export default __webpack_public_path__ + "static/media/jackets.6054f4d4.svg";